import { render, staticRenderFns } from "./teamsAppLeftPanel.vue?vue&type=template&id=1b818e61"
import script from "./teamsAppLeftPanel.vue?vue&type=script&lang=ts"
export * from "./teamsAppLeftPanel.vue?vue&type=script&lang=ts"
import style0 from "./teamsAppLeftPanel.vue?vue&type=style&index=0&id=1b818e61&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports